
const masks = {
    optionMask: (value) => {
        const cleaned = value.replace(/[^0-9]/g, "");

        const limited = cleaned.slice(0, 1);

        return `option ${limited}`;
    },
    intWithSemicolon: (string) => {
        let cleaned = string.replace(/[^0-9;]/g, "");

        cleaned = cleaned.replace(/;{2,}/g, ";");

        const parts = cleaned.split(";").map((part) => part.slice(0, 2));

        return parts.join(";");
    },
    cellWithCountryCode: (countryCode, number) => {
        const cleaned = number.replace(/\D/g, "");

        const ddd = cleaned.slice(0, 2);
        const firstFive = cleaned.slice(2, 7);
        const lastFour = cleaned.slice(7, 11);

        let masked = "";
        if (ddd) masked += `(${ddd}) `;
        if (firstFive) masked += firstFive;
        if (lastFour) masked += `-${lastFour}`;

        return `${countryCode} ${masked}`;
    },
    unmask: (string) => string.replace(/[^a-zA-Z0-9]/g, ""),
    number: (string) => string.replace(/\D/g, ""),
    state: (string) => string.replace(/\d/, ""),
    hour: (string) =>
        String(string)
            .replace(/\D/, "")
            .slice(0, 4)
            .replace(/(\d{2})(\d{2})/, (_, h, m) => {
                const hours = Math.min(23, parseInt(h, 10)).toString().padStart(2, "0");
                const minutes = Math.min(59, parseInt(m, 10))
                    .toString()
                    .padStart(2, "0");
                return `${hours}:${minutes}`;
            }),
    maskYear: (value) => {
        const numericValue = Number(String(value).replace(/\D/g, ""));
        const yearString = numericValue.toString().slice(0, 4);
        return yearString.padStart(4, "0");
    },
    validateYouTubeUrl: (url) => {
        const regex = /^(https?\:\/\/)?(www\.youtube\.com|youtu\.?be)\/.+$/;
        return regex.test(url);
    },
    cpf: (string) =>
        string
            .replace(/\D/g, "")
            .replace(/(\d{3})(\d)/, "$1.$2")
            .replace(/(\d{3})(\d)/, "$1.$2")
            .replace(/(\d{3})(\d{1,2})/, "$1-$2")
            .replace(/(-\d{2})\d+?$/, "$1"),
    rg: (string) =>
        string
            .replace(/\D/g, "")
            .replace(/(\d{2})(\d)/, "$1.$2")
            .replace(/(\d{3})(\d)/, "$1.$2")
            .replace(/(\d{3})(\d{1,2})/, "$1-$2")
            .replace(/(-\d{1})\d+?$/, "$1"),
    cnpj: (string) =>
        string
            .replace(/\D/g, "")
            .replace(/(\d{2})(\d)/, "$1.$2")
            .replace(/(\d{3})(\d)/, "$1.$2")
            .replace(/(\d{3})(\d)/, "$1/$2")
            .replace(/(\d{4})(\d{1,2})/, "$1-$2")
            .replace(/(-\d{2})\d+?$/, "$1"),
    document: (string) => {
        if (string.length < 12) {
            return string
                .replace(/\D/g, "")
                .replace(/(\d{3})(\d)/, "$1.$2")
                .replace(/(\d{3})(\d)/, "$1.$2")
                .replace(/(\d{3})(\d{1,2})/, "$1-$2")
                .replace(/(-\d{2})\d+?$/, "$1");
        }

        return string
            .replace(/\D/g, "")
            .replace(/(\d{2})(\d)/, "$1.$2")
            .replace(/(\d{3})(\d)/, "$1.$2")
            .replace(/(\d{3})(\d)/, "$1/$2")
            .replace(/(\d{4})(\d{1,2})/, "$1-$2")
            .replace(/(-\d{2})\d+?$/, "$1");
    },
    zipcode: (string) =>
        string
            .replace(/\D/g, "")
            .replace(/(\d{5})(\d)/, "$1-$2")
            .replace(/(-\d{3})\d+?$/, "$1"),
    phone: (string) =>
        string
            .replace(/\D/g, "")
            .replace(/(\d{2})(\d)/, "($1) $2")
            .replace(/(\d{4})(\d)/, "$1-$2")
            .replace(/(-\d{4})\d+?$/, "$1"),
    cell: (string) =>
        string
            .replace(/\D/g, "")
            .replace(/(\d{2})(\d)/, "($1) $2")
            .replace(/(\d{5})(\d)/, "$1-$2")
            .replace(/(-\d{4})\d+?$/, "$1"),
    currency: (value) => {
        const string = value.toString();

        if (string.replace(/\D/g, "") !== "")
            return (parseInt(string.replace(/\D/g, ""), 10) / 100).toLocaleString(
                "pt-BR",
                {
                    minimumFractionDigits: 2,
                }
            );

        return "0,00";
    },
    currencyAllPlatforms: (value) => {
        if (typeof value === "number") {
            const [currency, cents] = (value / 100).toFixed(2).toString().split(".");

            return `R$ ${currency.replace(/\B(?=(\d{3})+(?!\d))/g, ".")},${cents}`;
        }

        return "R$ 0,00";
    },
    percentage: (string) => {
        let number = Number(String(string).replace(/\D/g, ""));
        if (number > 100) number = 100;
        return `${number}`;
    },
    creditCard: (value) =>
        value
            .replace(/\D/g, "")
            .replace(/(\d{4})(\d)/, "$1 $2")
            .replace(/(\d{4})(\d)/, "$1 $2")
            .replace(/(\d{4})(\d)/, "$1 $2")
            .replace(/(.\d{4})\d+?$/, "$1"),

    creditCardDate: (value) => {
        value = value
            .replace(/\D/g, "")
            .replace(/([\d]{4})/, "$1")
            .replace(/([\d]{4})[\d]+?$/, "$1")
            .replace(/([\d]{2})([\d]{1})/, "$1/$2");
        const dates = value.split("/");
        if (dates.length) {
            if (parseInt(dates[0], 10) > 12) dates[0] = "12";
            return dates.join("/");
        }
        return value;
    },
    cep: (cep) => {
        const numericCep = cep.replace(/\D/g, "").slice(0, 8);
        return numericCep.replace(/(\d{5})(\d{3})/, "$1-$2");
    },

    date: (value) => {
        const cleaned = value.replace(/\D/g, "");

        const day = cleaned.slice(0, 2);
        const month = cleaned.slice(2, 4);
        const year = cleaned.slice(4, 8);

        const formattedDate = [day, month, year].filter(Boolean).join("/");

        return formattedDate;
    },
    cvv: (value) =>
        value
            .replace(/[^\d]/g, "")
            .replace(/([\d]{4})/, "$1")
            .replace(/([\d]{4})[\d]+?$/, "$1"),
};

export default masks